
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class OrderLaborGrid extends Serenity.EntityGrid<OrderLaborRow, any> {
        protected getColumnsKey() { return 'Purchase.OrderLabor'; }
        protected getIdProperty() { return OrderLaborRow.idProperty; }
        protected getInsertPermission() { return OrderLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderLaborRow.localTextPrefix; }
        protected getService() { return OrderLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}